<template>
  <div>
    <van-list
      v-model="loading"
      :finished="finished"
      :offset="20"
      finished-text="没有更多了"
      @load="onLoad"
    >
      <div v-for="leaveInfo in leaveInfoList" :key="leaveInfo.id">
        <leave-history :leaveInfo="leaveInfo" />
      </div>
      <!-- <van-cell v-for="item in list" :key="item" :title="item" /> -->
    </van-list>
  </div>
</template>

<script>
import LeaveHistory from "./children/LeaveHistory.vue";
import { Notify } from "vant";

export default {
  components: { LeaveHistory },
  data() {
    return {
      leaveInfoList: [],
      loading: false,
      finished: false,
      current: 1,
    };
  },
  mounted() {
    // this.getLeaveList();
  },
  methods: {
    onLoad() {
      this.getLeaveList();
    },
    getLeaveList() {
      this.axios({
        method: "get",
        url: "/api/blade-food/studentleave/ignore/page",
        params: {
          current: this.current,
          size: 20,
          status: 1,
          studentName: sessionStorage.stuName,
          studentId: sessionStorage.studentId,
        },
      })
        .then((res) => {
          this.leaveInfoList.push(...res.data.data.records);
          console.log(res);
          this.finished = res.data.data.records.length < 20;
          this.current++;
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
          this.finished = true;
          Notify({ type: "danger", message: "查询失败,请重试。" });
        });
    },
  },
};
</script>

<style scoped>
</style>